import { delegate } from '../utils/tools';
import * as preact from 'preact';
import * as bodyLock from '../utils/dom/body-lock';
import * as globalOptions from '../config/options';
import globalState from '../config/state';
import { ToolsSidebar } from './tools-menu';

let el = {};

let isOpen = false;
let isRendered = false;

let translateBodyOff = '-400px';
let translateToolsOff = '400px';

function renderTools() {
	let container = document.createElement('div');
	el.topNav.parentNode.appendChild(container);

	preact.render(<ToolsSidebar />, container);
	isRendered = true;

	el.toolNav = document.querySelector('[data-js=tools-nav]');
}

function showTools() {
	bodyLock.lock();

	el.toggle.classList.add('menu-trigger--active');
	el.toolNav.style.transform = 'translateX(0)';
	el.topNav.style.transform = `translateX(${translateBodyOff})`;
	el.header.style.transform = `translateX(${translateBodyOff})`;
	el.content.style.transform = `translateX(${translateBodyOff})`;

	if (el.alert) {
		el.alert.style.transform = `translateX(${translateBodyOff})`;
	}

	isOpen = true;

	el.toolNav.querySelector('.tools-nav--focusable').focus();
}

function hideTools() {
	bodyLock.unlock();
	el.toggle.classList.remove('menu-trigger--active');
	el.toolNav.style.transform = `translateX(${translateToolsOff})`;
	el.topNav.style.transform = '';
	el.header.style.transform = '';
	el.content.style.transform = '';

	if (el.alert) {
		el.alert.style.transform = '';
	}

	isOpen = false;
}

function toggleTools(event) {
	event.stopPropagation();

	if (!isRendered) {
		renderTools();
		showTools();
		return;
	}

	if (isOpen) {
		hideTools();
		return;
	}

	showTools();
}

function maybeCloseToolMenu(event) {
	if (!isOpen) {
		return;
	}

	let toolsContainer = document.querySelector('[data-js="tools-nav"]');
	let notInToolsMenu =
		event.target !== toolsContainer &&
		!toolsContainer.contains(event.target);

	if (notInToolsMenu) {
		hideTools();
	}
}

/**
 * @function init
 * @description Kick off this modules functionality
 */

export default function init() {
	el.topNav = document.querySelector('[data-js=top-nav]');
	if (!el.topNav) {
		return;
	}

	el.header = document.querySelector('[data-js=site-header]');
	el.content = document.querySelector('[data-js=site-wrap]');
	el.footer = document.querySelector('[data-js=secondary-footer-nav]');
	el.toggle = document.querySelector('[data-js=trigger-tools-menu]');
	el.alert = document.querySelector('[data-js=sto-alert]');

	delegate(el.topNav, '[data-js="trigger-tools-menu"]', 'click', toggleTools);

	document.addEventListener('click', maybeCloseToolMenu);

	document.addEventListener('modern_tribe/resize_executed', () => {
		if (globalState.v_width < globalOptions.NAV_BREAKPOINT && isOpen) {
			hideTools();
		}
	});

	console.info('Initialized tools navigation scripts');
}
